import { isRouteErrorResponse, useRouteError } from 'react-router'

import { ErrorBoundaryInfo } from 'shared/dashboard/ErrorBoundaryInfo'

const DEFAULT_HEADING = 'We could not render the page'
const DEFAULT_MESSAGE = 'Something unexpected happened. We have been notified and are looking into it.'

function getHeadingFromError (error: unknown) {
  if (isRouteErrorResponse(error)) {
    return error.data.heading ?? DEFAULT_HEADING
  }

  return DEFAULT_HEADING
}

function getMessageFromError (error: unknown) {
  if (isRouteErrorResponse(error)) {
    return error.data.message ?? DEFAULT_MESSAGE
  }

  return DEFAULT_MESSAGE
}

function getDebugInfoFromError (error: unknown) {
  if (isRouteErrorResponse(error)) {
    return error.data.requestId
      ? { 'Request ID': error.data.requestId }
      : undefined
  }

  return undefined
}

export function PageErrorPage () {
  const error = useRouteError()

  return (
    <div className='grow flex flex-col items-center justify-center'>
      <ErrorBoundaryInfo
        debugInfo={getDebugInfoFromError(error)}
        heading={getHeadingFromError(error)}
        message={getMessageFromError(error)}
      />
    </div>
  )
}
